import React from "react"
import styled from "styled-components"
import samImage from "resources/assets/sam/sam.svg"
// import blocksImage from "resources/assets/sam/graphs.svg"
// import stockGraphImage from "resources/assets/sam/graph.svg"
// import prop1 from "resources/assets/sam/prop1.svg"
// import prop2 from "resources/assets/sam/prop2.svg"
// import gradient1 from "resources/assets/sam/gradient1.svg"
// import gradient2 from "resources/assets/sam/gradient2.svg"
// import gradient3 from "resources/assets/sam/gradient3.svg"
import giftIcon from "resources/assets/gift.svg"
import ArrowLeftIcon from "resources/assets/arrow-blue.svg"
import { ActionButton } from "components/elements/Button"
import { Box, Grid, Typography } from "@material-ui/core"
import LinesBg from "resources/assets/lines-bg.svg"
import { Link } from "gatsby"
import { events } from "analytics/events"
import { MobileDownloadManager } from "components/utils/download-manager"
import { pushToFirebase } from "analytics/manager"

// const StyledAnimation = styled.div`
//   position: relative;
//   overflow: hidden;

//   div.blocks {
//     width: 350px;
//     height: 320px;
//     position: relative;
//     bottom: -135px;
//     background: url(${blocksImage});
//     background-repeat: no-repeat;
//     animation-name: animation-blocks;
//     animation-duration: 1s;
//     transform-origin: bottom;
//     animation-fill-mode: forwards;
//     animation-iteration-count: 1;
//     z-index: 1s;
//     z-index: 1;
//   }

//   @keyframes animation-blocks {
//     0% {
//       transform: scaleY(0.2);
//     }

//     100% {
//       transform: scaleY(1);
//     }
//   }

//   div.stock-graph {
//     width: 80px;
//     height: 50px;
//     position: absolute;
//     opacity: 0;
//     background: url(${stockGraphImage});
//     background-repeat: no-repeat;
//     animation-name: animation-stock-graph;
//     animation-duration: 0.6s;
//     transform-origin: bottom;
//     animation-fill-mode: forwards;
//     animation-iteration-count: 1;
//     z-index: 0;
//     animation-delay: 1s;
//   }

//   @keyframes animation-stock-graph {
//     from {
//       bottom: 6px;
//       right: 90px;
//       opacity: 0%;
//     }
//     to {
//       bottom: 35px;
//       right: -15px;
//       opacity: 100%;
//     }
//   }

//   div.circle {
//     width: 100px;
//     height: 50px;
//     position: absolute;
//     opacity: 0;
//     background: url(${prop1});
//     background-repeat: no-repeat;
//     animation-name: animation-circle;
//     animation-duration: 0.6s;
//     transform-origin: bottom;
//     animation-fill-mode: forwards;
//     animation-iteration-count: 1;
//     animation-delay: 1s;
//   }

//   @keyframes animation-circle {
//     from {
//       bottom: 60px;
//       left: 60px;
//       opacity: 0;
//     }
//     to {
//       bottom: 100px;
//       left: 20px;
//       opacity: 100%;
//     }
//   }

//   div.ball {
//     width: 100px;
//     height: 50px;
//     position: absolute;
//     opacity: 0;
//     background: url(${prop2});
//     background-repeat: no-repeat;
//     animation-name: animation-ball;
//     animation-duration: 0.6s;
//     transform-origin: bottom;
//     animation-fill-mode: forwards;
//     animation-iteration-count: 1;
//     z-index: 1;
//     animation-delay: 1s;
//   }

//   @keyframes animation-ball {
//     from {
//       bottom: 0;
//       left: 80px;
//       opacity: 0%;
//     }
//     to {
//       bottom: 10px;
//       left: -5px;
//       opacity: 100%;
//     }
//   }

//   div.gradient1 {
//     width: 50px;
//     height: 40px;
//     position: absolute;
//     opacity: 0;
//     background: url(${gradient1});
//     background-repeat: no-repeat;
//     animation-name: animation-gradient1;
//     animation-duration: 0.6s;
//     transform-origin: bottom;
//     animation-fill-mode: forwards;
//     animation-iteration-count: 1;
//     z-index: 1;
//     animation-delay: 1s;
//   }

//   @keyframes animation-gradient1 {
//     from {
//       top: 120px;
//       left: 60px;
//       opacity: 0;
//     }
//     to {
//       top: 80px;
//       left: 30px;
//       opacity: 100%;
//     }
//   }

//   div.gradient2 {
//     width: 50px;
//     height: 50px;
//     position: absolute;
//     opacity: 0;
//     background: url(${gradient2});
//     background-repeat: no-repeat;
//     animation-name: animation-gradient2;
//     animation-duration: 0.6s;
//     transform-origin: bottom;
//     animation-fill-mode: forwards;
//     animation-iteration-count: 1;
//     z-index: 1;
//     animation-delay: 1s;
//   }

//   @keyframes animation-gradient2 {
//     from {
//       top: 80px;
//       right: 80px;
//       opacity: 0;
//     }
//     to {
//       top: 50px;
//       right: 10px;
//       opacity: 100%;
//     }
//   }

//   div.gradient3 {
//     width: 60px;
//     height: 50px;
//     position: absolute;
//     opacity: 0;
//     background: url(${gradient3});
//     background-repeat: no-repeat;
//     animation-name: animation-gradient3;
//     animation-duration: 0.6s;
//     transform-origin: bottom;
//     animation-fill-mode: forwards;
//     animation-iteration-count: 1;
//     z-index: 1;
//     animation-delay: 1s;
//   }

//   @keyframes animation-gradient3 {
//     from {
//       bottom: 0px;
//       right: 20px;
//       opacity: 0;
//     }
//     to {
//       bottom: -10px;
//       right: -10px;
//       opacity: 100%;
//     }
//   }

//   img.sam {
//     height: 260px;
//     width: auto;
//     position: absolute;
//     bottom: -550px;
//     left: 45px;
//     transform: translateY(-550px);
//     animation: slide-up 0.6s linear normal;
//     z-index: 3;
//     opacity: 0;
//     animation-fill-mode: forwards;
//     animation-delay: 1.5s;
//   }

//   @keyframes slide-up {
//     from {
//       transform: translateY(0px);
//       opacity: 50%;
//     }
//     to {
//       transform: translateY(-550px);
//       opacity: 100%;
//     }
//   }
// `

const StyledContainer = styled.div`
  --primary: rgba(28, 37, 255, 0.1);
  --secondary: rgba(255, 23, 157, 0.1);

  .pink {
    color: #f81e7a;
  }
  .grey {
    text-decoration: line-through;
    color: #5e6074;
  }
  .blue {
    color: #1678ea;
  }

  background: url(${LinesBg});
  padding: 0px 16px;
`

const StyledDiv = styled.div`
  h2 {
    font-weight: 600;
    font-size: 18px;
  }
  h3 {
    font-size: 16px;
    font-weight: 500;
  }

  h1 {
    font-size: 30px;
  }

  h6 {
    font-weight: 600;
    font-size: 16px;
  }
  h5 {
    font-size: 16px;
  }

  .gift-icon {
    vertical-align: text-top;
    display: inline;
    height: 15px;
  }

  .grid-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
    padding: 86px 8px 64px 8px;
  }

  .arrow {
    height: 10px;
    margin-left: 6px;
  }

  .hero-image {
    height: 260px;
    width: auto;
    max-width: 500px;
    margin-top: 40px;
  }
`

export default () => {
  return (
    <StyledContainer>
      <StyledDiv>
        <Grid
          container
          justify="space-between"
          alignItems="center"
          className="grid-container"
        >
          <Grid item xs>
            <Typography variant="h3" className="grey">
              Stop being a fantasy player
            </Typography>
            <Box py={1} />
            <Typography variant="h1">Start Being A Fantasy Owner</Typography>
            <Box py={1} />
            <Typography variant="h2" className="pink">
              Trade fantasy stocks in cricket players
            </Typography>
          </Grid>

          <Grid item xs>
            <Grid container justify="flex-end">
              {/* <StyledAnimation>
                <Grid container direction="row" alignItems="flex-end">
                  <img
                    src={samImage}
                    className="sam"
                    alt="Sam Curran standing with sixer bat in hand"
                  />
                  <div className="blocks"></div>
                  <div className="circle"></div>
                  <div className="ball"></div>
                  <div className="gradient1"></div>
                  <div className="gradient2"></div>
                  <div className="gradient3"></div>
                  <div className="stock-graph"></div>
                </Grid>
              </StyledAnimation> */}
              <Grid container direction="row" alignItems="flex-end">
                <img
                  className="hero-image"
                  src={samImage}
                  alt="Sam Curran standing with sixer bat in hand"
                />
              </Grid>
            </Grid>
            <Box mt={5} />
            <ActionButton
              onClick={() =>
                MobileDownloadManager(events.web.web_home_downloadSixer)
              }
              color="secondary"
              title={"Download Sixer"}
            />

            <Box mt={3} />
            <Typography variant="h6">
              <img
                loading="lazy"
                src={giftIcon}
                className="gift-icon"
                alt="gift icon"
              />{" "}
              Refer your friends and get Discount Bonus!{" "}
              <Link
                to="/about/free-coins-and-stocks"
                onClick={() => {
                  pushToFirebase(events.web.web_home_aboutReferrals)
                }}
              >
                <Box mt={0} />
                <Typography variant="h5" className="blue">
                  Learn more about referrals{" "}
                  <img
                    loading="lazy"
                    className="arrow"
                    src={ArrowLeftIcon}
                    alt="arrow icon"
                  ></img>
                </Typography>
              </Link>
            </Typography>
          </Grid>
        </Grid>
      </StyledDiv>
    </StyledContainer>
  )
}
